import type { KeyboardEvent } from 'react';
import { Table } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import SpinnerBlock from 'components/others/SpinnerBlock';
import type { ClientContactRow } from '../model/clientContactTypes';
import ClientContactsTableBody from './ClientContactsTableBody';

interface ClientContactsTableProps {
    rows: ClientContactRow[];
    showSpinner?: boolean;
    canEdit: boolean;
    editingKey: string | null;
    editValue: string;
    onEditValueChange: (value: string) => void;
    onEditKeyDown: (event: KeyboardEvent<HTMLInputElement>) => void;
    onStartEdit: (row: ClientContactRow) => void;
    onSaveEdit: () => void;
    onCancelEdit: () => void;
    onRemove: (row: ClientContactRow) => void;
}

const ClientContactsTable = ({
    rows,
    showSpinner = false,
    canEdit,
    editingKey,
    editValue,
    onEditValueChange,
    onEditKeyDown,
    onStartEdit,
    onSaveEdit,
    onCancelEdit,
    onRemove,
}: ClientContactsTableProps) => {
    const { t } = useTranslation(['Clients']);

    return (
        <div className="position-relative">
            <SpinnerBlock onlyBlur={true} show={showSpinner} />
            <div className="crm-table-wrap">
                <Table className="ClientContactsTable table-hover align-middle mb-0">
                    <thead>
                        <tr className="bg-light">
                            <td className="head-status">{t('contacts.columns.type')}</td>
                            <td className="head-name">{t('contacts.columns.value')}</td>
                            <td className="head-action">{t('contacts.columns.actions')}</td>
                        </tr>
                    </thead>
                    <ClientContactsTableBody
                        rows={rows}
                        emptyText={t('contacts.empty')}
                        disabled={showSpinner}
                        canEdit={canEdit}
                        editingKey={editingKey}
                        editValue={editValue}
                        onEditValueChange={onEditValueChange}
                        onEditKeyDown={onEditKeyDown}
                        onStartEdit={onStartEdit}
                        onSaveEdit={onSaveEdit}
                        onCancelEdit={onCancelEdit}
                        onRemove={onRemove}
                    />
                </Table>
            </div>
        </div>
    );
};

export default ClientContactsTable;
